import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '@/store/store'

interface SportsbookState {
	selectedSportsbookId: string | null
}

const initialState: SportsbookState = {
	selectedSportsbookId: null,
}

const sportsbookSlice = createSlice({
	name: 'sportsbook',
	initialState,
	reducers: {
		setSelectedSportsbook(state, action: PayloadAction<string>) {
			state.selectedSportsbookId = action.payload
		},
		clearSelectedSportsbook(state) {
			state.selectedSportsbookId = null
		},
	},
})

export const { setSelectedSportsbook, clearSelectedSportsbook } = sportsbookSlice.actions

export const selectSelectedSportsbookId = (state: RootState) => state.sportsbook.selectedSportsbookId

export default sportsbookSlice.reducer
